var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundPatternTerms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1176,
    height: 286,
    viewBox: "0 0 1176 286",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2559_2308",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 146,
    y: -91,
    width: 884,
    height: 883
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 877.633,
    height: 877.633,
    transform: "translate(146.653 -85.9355) rotate(-0.314706)",
    fill: "url(#paint0_radial_2559_2308)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2559_2308)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2559_2308)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2559_2308)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 176.213,
    y1: -86.0993,
    x2: 181.033,
    y2: 791.521,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.721,
    y1: -86.4196,
    x2: 239.541,
    y2: 791.2,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 293.229,
    y1: -86.7419,
    x2: 298.049,
    y2: 790.878,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 351.736,
    y1: -87.0622,
    x2: 356.557,
    y2: 790.558,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 410.244,
    y1: -87.3845,
    x2: 415.065,
    y2: 790.235,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 468.753,
    y1: -87.7048,
    x2: 473.573,
    y2: 789.915,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 527.261,
    y1: -88.0271,
    x2: 532.081,
    y2: 789.593,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 585.769,
    y1: -88.3474,
    x2: 590.589,
    y2: 789.273,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 644.276,
    y1: -88.6696,
    x2: 649.097,
    y2: 788.95,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 702.784,
    y1: -88.99,
    x2: 707.605,
    y2: 788.63,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 761.293,
    y1: -89.3122,
    x2: 766.114,
    y2: 788.308,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 819.801,
    y1: -89.6345,
    x2: 824.621,
    y2: 787.985,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 878.309,
    y1: -89.9548,
    x2: 883.129,
    y2: 787.665,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 936.816,
    y1: -90.2771,
    x2: 941.637,
    y2: 787.343,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 995.325,
    y1: -90.5974,
    x2: 1000.15,
    y2: 787.023,
    stroke: "#32834B",
    strokeWidth: 0.609468
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2559_2308)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 1.02469,
    y1: 31.5781,
    x2: 1171.18,
    y2: 25.1507,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.34598,
    y1: 90.0859,
    x2: 1171.51,
    y2: 83.6586,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.66727,
    y1: 148.594,
    x2: 1171.83,
    y2: 142.166,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.98856,
    y1: 207.102,
    x2: 1172.15,
    y2: 200.674,
    stroke: "#32834B",
    strokeWidth: 0.609468
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.30985,
    y1: 265.611,
    x2: 1172.47,
    y2: 259.184,
    stroke: "#32834B",
    strokeWidth: 0.609468
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2559_2308",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(438.817 -0.000104622) rotate(90) scale(877.633 458.068)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2559_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1170.18,
    height: 877.633,
    fill: "white",
    transform: "translate(0.383789 -85.1328) rotate(-0.314706)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2559_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1170.18,
    height: 877.633,
    fill: "white",
    transform: "translate(0.383789 -85.1328) rotate(-0.314706)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2559_2308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1170.18,
    height: 877.633,
    fill: "white",
    transform: "translate(0.383789 -85.1328) rotate(-0.314706)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPatternTerms);
export default __webpack_public_path__ + "static/media/BackgroundPatternTerms.380868634fef953e0ca1a2ba42121366.svg";
export { ForwardRef as ReactComponent };